export default __webpack_public_path__ + "static/media/bottomLogo.1b2038a1.png";